(function(root){
  'use strict';
  const names={pallet:'Pallettransport',rush:'Spoedtransport',lift:'Transport met laadklep',business:'Zakelijk transport',moving:'Verhuizen & meubels'};
  const number=v=>v===''||v==null?null:Number(v);
  const money=n=>new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR'}).format(n);
  function estimate(d){
    if(d.service==='moving'){
      const h=number(d.hours);
      if(!Number.isFinite(h)||h<1||h>24)return null;
      const ex=h*(d.helper==='Ja'?95:65);
      return {ex,inc:Math.round(ex*121)/100,label:'Indicatief uurbedrag',detail:`${h} uur × ${money(d.helper==='Ja'?95:65)} excl. btw. Alleen afgesproken inzet, zonder aanvullende kosten.`};
    }
    const km=number(d.km);
    if(!Number.isFinite(km)||km<=0||km>5000)return null;
    const rate=d.service==='rush'?1.5:1.25;
    const component=km*rate*(km>30?1.3:1);
    const ex=Math.max(85,component);
    return {ex,inc:Math.round(ex*121)/100,label:'Indicatief kilometerbedrag',detail:`${km} km × ${money(rate)}${km>30?' + 30% afstandstoeslag':''}${component<85?'; lokaal minimumtarief toegepast':''}. Aanrijafstand en extra kosten niet inbegrepen.`};
  }
  function capacity(d){
    const warnings=[];const weight=number(d.weight),item=number(d.itemweight);
    if(weight>950)warnings.push('Het totaalgewicht is hoger dan het laadvermogen van 950 kg. Pas de aanvraag aan of bespreek een andere oplossing telefonisch.');
    if(d.lift==='Ja'&&item>750)warnings.push('Het zwaarste voorwerp overschrijdt de laadklepcapaciteit van 750 kg. Een andere laadmethode moet vooraf worden afgesproken.');
    if(d.lift==='Ja'&&item>650&&item<=750)warnings.push('Het voorwerp nadert de laadklepcapaciteit. Het gewicht van hulpmiddelen en andere belasting op het platform telt ook mee.');
    if(item&&weight&&item>weight)warnings.push('Het gewicht van het zwaarste voorwerp is groter dan het totaalgewicht. Controleer beide gewichten.');
    const dims=['length','width','height'].map(k=>number(d[k]));
    if(dims.every(v=>v!=null)){
      const base=[dims[0],dims[1]].sort((a,b)=>b-a);
      if(dims[2]>220||base[0]>420||base[1]>212)warnings.push('De opgegeven buitenmaten passen niet binnen 420 × 212 × 220 cm met deze hoogte. Bespreek de lading telefonisch; de maatcontrole is geen garantie dat een voorwerp kan worden geladen.');
    }
    return warnings;
  }
  function validate(d,today){
    const errors=[];
    for(const [k,label] of [['from','ophaaladres'],['to','afleveradres'],['date','gewenste datum'],['cargo','lading'],['name','naam'],['email','e-mailadres'],['phone','telefoonnummer']])if(!String(d[k]||'').trim())errors.push(`Vul uw ${label} in.`);
    if(d.date&&today&&d.date<today)errors.push('Kies vandaag of een latere datum.');
    if(!names[d.service])errors.push('Kies een transportdienst.');
    const w=number(d.weight);if(!Number.isFinite(w)||w<1||w>950)errors.push('Vul een totaalgewicht tussen 1 en 950 kg in.');
    if(d.email&&!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email))errors.push('Controleer uw e-mailadres.');
    if(d.phone&&d.phone.replace(/\D/g,'').length<6)errors.push('Controleer uw telefoonnummer.');
    if(d.itemweight&&number(d.itemweight)>w)errors.push('Het zwaarste voorwerp kan niet meer wegen dan de totale lading.');
    const dims=['length','width','height'].map(k=>number(d[k]));
    if(dims.some(v=>v!=null)&&!dims.every(v=>v!=null))errors.push('Vul alle drie de buitenmaten in, of laat alle maten leeg.');
    if(d.service==='moving'&&(!Number.isFinite(number(d.hours))||number(d.hours)<1||number(d.hours)>24))errors.push('Vul een verwachte inzet tussen 1 en 24 uur in.');
    return errors;
  }
  function message(d){
    const lines=['Offerteaanvraag — Delta Express Transport','',`Dienst: ${names[d.service]||d.service}`,`Ophalen: ${d.from}`,`Afleveren: ${d.to}`,`Gewenste datum: ${d.date}`];
    if(d.time)lines.push(`Gewenste tijden: ${d.time}`);
    lines.push('',`Lading: ${d.cargo}`);
    if(d.quantity)lines.push(`Aantal: ${d.quantity}`);
    lines.push(`Totaal gewicht: ${d.weight} kg`);
    if(d.length&&d.width&&d.height)lines.push(`Grootste voorwerp (L × B × H): ${d.length} × ${d.width} × ${d.height} cm`);
    lines.push(`Laadklep: ${d.lift}`);
    if(d.itemweight)lines.push(`Zwaarste voorwerp: ${d.itemweight} kg`);
    if(d.service==='moving')lines.push(`Verwachte inzet: ${d.hours} uur`,`Extra helper: ${d.helper}`);
    if(d.access)lines.push('',`Bereikbaarheid / opmerkingen: ${d.access}`);
    const e=estimate(d);
    if(e)lines.push('',`Rekenvoorbeeld: ${money(e.ex)} excl. btw / ${money(e.inc)} incl. btw`,e.detail,'Dit is geen complete offerte. Graag de totale prijs inclusief aanrijtijd, wachttijd en aanvullende kosten bevestigen.');
    const w=capacity(d);if(w.length)lines.push('','Vooraf te beoordelen:',...w);
    lines.push('',`Naam: ${d.name}`);
    if(d.company)lines.push(`Bedrijf: ${d.company}`);
    lines.push(`E-mail: ${d.email}`,`Telefoon: ${d.phone}`,'','Graag uw beschikbaarheid en complete transportprijs bevestigen. Deze aanvraag is vrijblijvend en nog geen boeking.');
    return lines.join('\n');
  }
  const api={names,money,estimate,capacity,validate,message};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;
  else root.QuoteEngine=api;
})(typeof window==='undefined'?globalThis:window);
